import { createFileRoute } from "@tanstack/react-router";
import {
  CollectionPage,
  CollectionErrorComponent,
  CollectionNotFoundComponent,
} from "@/pages/CollectionPage";
import { allProductsLoader, allProductsHeadEn } from "@/pages/AllProductsPage";

export const Route = createFileRoute("/en/alle")({
  loader: allProductsLoader,
  head: allProductsHeadEn,
  component: CollectionPage,
  errorComponent: CollectionErrorComponent,
  notFoundComponent: CollectionNotFoundComponent,
});
